import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@calm-web/design-system';

import Header from '@/components/header/Header';
import FullscreenBackground from '@/components/image/FullscreenBackground';
import FullscreenOverlay from '@/components/image/FullscreenOverlay';
import { useAnalytics } from '@/hooks/analytics';
import { useAppLoadedState } from '@/hooks/store';

import messages from './messages';
import { Body, ButtonPadding, Container, Grid, Head, Wrapper } from './styles';

const NotFound = (): JSX.Element => {
	const { logEvent } = useAnalytics();
	const { formatMessage } = useIntl();
	const appLoaded = useAppLoadedState();
	const router = useRouter();

	useEffect(
		() => {
			if (!appLoaded) return;
			logEvent({
				eventName: 'Not Found : Landed',
				eventProps: { original_url: router.asPath },
			});
		}, // TODO [WEB-1595]: Fix this exhaustive-deps issue
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[appLoaded],
	);

	return (
		<Wrapper>
			<Header />
			<FullscreenBackground src="/_n/images/jasper-lake-hi.webp" />
			<FullscreenOverlay gradient="gradientHome" mobileGradient="gradientHomeMobile" />
			<Grid columns={2}>
				<Container>
					<Head>{formatMessage(messages.title)}</Head>
					<Body>{formatMessage(messages.message1)}</Body>
					<Body>{formatMessage(messages.message2)}</Body>
					<ButtonPadding>
						<Button textColor="gray6" backgroundColor="white" href="/">
							{formatMessage(messages.cta)}
						</Button>
					</ButtonPadding>
				</Container>
			</Grid>
		</Wrapper>
	);
};

export default NotFound;
